import React, { useState, Fragment } from "react";

import chatpannelstyle from "../../style/components/bars/ActivityPannel.module.css";
import barpannel from "../../style/components/bars/Bars.module.css";
import SidePannelShimmer from "../ui/Loader/Shimmer/SidePannelShimmer";
import FallbackAvatar from "../ui/FallbackAvatar/FallbackAvatar";
import {
  getFirstCodePoint,
  renderTextWithEmojisActivity,
} from "../../utils/renderTextWithEmojis";
import { Emoji } from "emoji-picker-react";
import { getSelectedActivity } from "../../utils/auth";

const parseDelta = (delta, messageId) => {
  if (!Array.isArray(delta)) return null;

  return delta.map((op) => {
    if (!op.insert || typeof op.insert !== "string") return null;

    let content = renderTextWithEmojisActivity(op.insert);

    if (op.attributes) {
      // Apply underline
      if (op.attributes.underline) {
        content = <u>{content}</u>;
      }

      // Apply italic
      if (op.attributes.italic) {
        content = <em>{content}</em>;
      }

      // Apply bold
      if (op.attributes.bold) {
        content = <strong>{content}</strong>;
      }
    }

    return <Fragment>{content}</Fragment>;
  });
};
const ActivityPannel = ({ activity, loading, onSelectedConversation }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const selected = getSelectedActivity();
  const [imgError, setImgError] = useState({});
  const steps = ["All", "Mention", "React"]; // Step labels
  const [activeStep, setActiveStep] = useState(0); // Track active step

  const onSelectedPeople = (data) => {
    onSelectedConversation({ data });
  };
  const renderText = (text) => {
    if (!text) return null;

    try {
      // Attempt to parse as Delta format
      const delta = JSON.parse(text);
      if (Array.isArray(delta)) {
        return parseDelta(delta);
      }
    } catch (e) {
      // Plain text fallback
      return renderTextWithEmojisActivity(text);
    }

    // Fallback for non-JSON text
    return renderTextWithEmojisActivity(text);
  };
  const handleImgError = (id) => {
    setImgError((prev) => ({ ...prev, [id]: true }));
  };

  const renderContent = () => {
    if (loading) {
      return Array(9)
        .fill()
        .map((_, i) => (
          <div key={`channel-shimmer-${i}`} style={{ margin: "8px 0" }}>
            <SidePannelShimmer width="200px" height="35px" />
          </div>
        ));
    }

    // Filter data based on active step
    let displayData = [];
    if (activeStep === 0) {
      // All
      displayData = [
        ...(activity.get_mention_people || []),
        ...(activity.get_reaction_details || []),
      ];
    } else if (activeStep === 1) {
      // Mention
      displayData = activity.get_mention_people || [];
    } else if (activeStep === 2) {
      // React
      displayData = activity.get_reaction_details || [];
    }

    if (displayData.length === 0) {
      return (
        <p className={chatpannelstyle.NoActivityMessage}>No activity found</p>
      );
    }

    return displayData.map((item, index) => {
      const isMention = "mention_user_id" in item;
      const isReaction = "emoji" in item;

      return (
        <div
          // className={`${chatpannelstyle.activityview}${
          //   selected?.data?.activity_id === item?.activity_id
          //     ? chatpannelstyle.ActivityItemViewActive
          //     : ""
          // }`}
          className={`${chatpannelstyle.activityview} ${
            selected?.activity_id === item?.activity_id
              ? chatpannelstyle.ActivityItemViewActive
              : ""
          }`}
        >
          <p className={chatpannelstyle.ActivityItemViewParaMsg}>
            {item.activity_content}
          </p>
          <div
            key={`${isMention ? "mention" : "reaction"}-${index}`}
            onClick={() => onSelectedPeople(item)}
            className={`${chatpannelstyle.ActivityItemView}
            }`}
          >
            {!imgError[item.register_id || index] ? (
              <img
                src={`${apiUrl}${item.emp_pic}`}
                alt={item.name || item.sender_name}
                onError={() => handleImgError(item.register_id || index)}
              />
            ) : (
              <FallbackAvatar
                name={item.name || item.receiver_name}
                size={30}
              />
            )}
            <div className={chatpannelstyle.ActivityContent}>
              <p className={chatpannelstyle.ActivityItemViewParaNme}>
                {item.name || item.receiver_name}
              </p>
              <p className={chatpannelstyle.ActivityItemViewParaMsg}>
                {renderText(item.message)}
              </p>
              {isMention && (
                <div className={chatpannelstyle.MentionBadge}>Mention</div>
              )}
              {isReaction && (
                <div className={chatpannelstyle.ReactionBadge}>
                  <Emoji unified={getFirstCodePoint(item.emoji)} size={14} />
                </div>
              )}
              <div className={chatpannelstyle.ActivityMeta}>
                {item.time && <span>{item.time}</span>}
                {item.date && <span>{item.date}</span>}
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className={barpannel.BarsContainer}>
      <div className={barpannel.BarsContainerChild}>
        <div className={chatpannelstyle.ActivityPannelHeader}>
          <h3>Activity</h3>
        </div>

        <div className={chatpannelstyle.ActivityPannelSearch}>
          <div className={chatpannelstyle.ActivityPannelStepper}>
            <div className={chatpannelstyle.StepperWrapper}>
              {steps.map((label, index) => (
                <div
                  key={index}
                  className={chatpannelstyle.StepItem}
                  onClick={() => setActiveStep(index)}
                >
                  <div className={chatpannelstyle.StepLabel}>{label}</div>
                  <div
                    className={chatpannelstyle.StepLine}
                    style={{
                      backgroundColor: activeStep === index ? "#007bff" : "",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={chatpannelstyle.ActivityPannelListview}>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default ActivityPannel;
